import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { FormField, FormFields, Validator, FormState } from './@types';
import { isField, isPartialField } from './utils';

const moduleName = 'Form';
const createAction = actionCreatorFactory();

export const makeEmptyField: (value?: string) => FormField = (value = '') => ({ name: '', value, errors: [], touched: false, dirty: false });

// Actions

export const setField = createAction<{ name: string; field: Partial<FormField> | FormFields }>(`[${moduleName}] set field`);

export const clearField = createAction<string>(`[${moduleName}] clear field`);

export const setSubmitting = createAction<boolean>(`[${moduleName}] set submitting`);

export const setValidator = createAction<{ name: string; validate: Validator }>(`[${moduleName}] set validator`);

export const setGlobalErrors = createAction<Array<string>>(`[${moduleName}] set global errors`);

export const removeField = createAction<string>(`[${moduleName}] remove field`);

export const reducer = (initialState: FormState) =>
    reducerWithInitialState(initialState)
        .case(setField, (state, { name, field }) => {
            if (isPartialField(field) && name.includes('[')) {
                const arrayAccessRegex = /(\w+)\[(\d+)\]$/;
                const match = arrayAccessRegex.exec(name);
                const arrayName = match ? match[1] : name;
                const index = match ? Number(match[2]) : 0;
                const fieldArray = (state.fields[arrayName] || []) as FormField[];

                const existingField = fieldArray[index] || makeEmptyField();
                const newField: FormField = { ...existingField, ...field, name };

                let newFieldArray: FormField[] = [];
                if (Array.isArray(fieldArray)) {
                    newFieldArray = [...fieldArray.slice(0, index), newField, ...fieldArray.slice(index + 1)];
                } else {
                    newFieldArray[index] = newField;
                }

                return {
                    ...state,
                    fields: { ...state.fields, [arrayName]: newFieldArray },
                };
            } else if (isPartialField(field)) {
                const existingField = state.fields[name] && isField(state.fields[name]) ? (state.fields[name] as FormField) : makeEmptyField();
                const newField: FormField = { ...existingField, ...field, name };
                return {
                    ...state,
                    fields: { ...state.fields, [name]: newField },
                };
            }
            return {
                ...state,
                fields: { ...state.fields, [name]: field },
            };
        })
        .case(clearField, (state, name) => ({
            ...state,
            fields: Object.entries(state.fields).reduce((newFields, [key, val]) => {
                if (key != name) {
                    return newFields;
                }
                return {
                    ...newFields,
                    [key]: val,
                };
            }, {}),
        }))
        .case(setGlobalErrors, (state, globalErrors) => ({ ...state, globalErrors }))
        .case(setSubmitting, (state, submitting) => ({ ...state, submitting }))
        .case(removeField, (state, name) => {
            if (state.fields[name]) {
                const fields = { ...state.fields };
                delete fields[name];
                return {
                    ...state,
                    fields,
                };
            }
            return { ...state };
        });
